import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import { OpenLock as OpenLockIcon } from 'Icons';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyIntegrationsPage = React.lazy(() => import('./Pages'));

const companyConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:integrations.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.integrations.title',
            url: '/integrations-settings',
            Icon: OpenLockIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyIntegrationsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
            childItems: [],
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default companyConfiguration;
